<template>
  <div class="pt20">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('admin.column.add.back') }}</span>
    </div>
    <h4>{{ id ? $t('admin.column.add.edit') : $t('admin.column.add.create') }}</h4>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('admin.column.add.basicInfo') }}</div>
      <div class='list_wrap'>
        <div class="list">
          <a-form-item class="full" :label="$t('admin.column.add.name.label')" :colon="false">
            <a-input
              maxLength="6"
              allowClear
              :placeholder="$t('admin.column.add.name.placeholder')"
              v-decorator="['title', { rules: [{ required: true, message: $t('admin.column.add.name.required') }] }]">
            </a-input>
          </a-form-item>
        </div>
        <div class='list'>
          <a-form-item :label="$t('admin.column.add.type.label')" :colon="false">
            <a-select 
              allowClear 
              v-decorator="['type', { rules: [{ required: true, message: $t('admin.column.add.type.required') }] }]" 
              :placeholder="$t('admin.column.add.type.placeholder')" 
              :disabled="id">
              <a-select-option v-for="item in typeList" :key="item.id" :value="item.id" :disabled="[2, 90, 91].includes(item.id)">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('admin.column.add.status.label')" :colon="false">
            <a-select 
              allowClear 
              v-decorator="['status', { rules: [{ required: true, message: $t('admin.column.add.status.required') }] }]" 
              :placeholder="$t('admin.column.add.status.placeholder')">
              <a-select-option v-for="item in stateList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class='list' v-if="form.getFieldValue('type') === 5">
          <a-form-item class="full" :label="$t('admin.column.add.externalLink.label')" :colon="false">
            <a-input
              allowClear
              :placeholder="$t('admin.column.add.externalLink.placeholder')"
              v-decorator="['link', { rules: [
                { required: true, message: $t('admin.column.add.externalLink.required') }, 
                { type: 'url', message: $t('admin.column.add.externalLink.urlError') }
              ] }]">
            </a-input>
          </a-form-item>
        </div>
        <div class='list' v-if="form.getFieldValue('type') === 90">
          <a-form-item class="full" :label="$t('admin.column.add.domain.label')" :colon="false">
            <a-input
              allowClear
              maxLength="10"
              :placeholder="$t('admin.column.add.domain.placeholder')"
              :addon-after="addonAfter"
              v-decorator="['customDomainPrefix', { rules: [
                { required: true, message: $t('admin.column.add.domain.required') }, 
                { pattern: /^[a-zA-Z0-9]+$/, message: $t('admin.column.add.domain.formatError') }
              ] }]">
            </a-input>
          </a-form-item>
        </div>
        <div class='list'>
          <a-form-item :label="$t('admin.column.add.clickable.label')" :colon="false">
            <a-select 
              v-decorator="['is_click', { rules: [{ required: true, message: $t('admin.column.add.clickable.required') }] }]" 
              :placeholder="$t('admin.column.add.clickable.placeholder')">
              <a-select-option value="1">{{ $t('admin.column.add.clickable.yes') }}</a-select-option>
              <a-select-option value="2">{{ $t('admin.column.add.clickable.no') }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class='list' v-if="form.getFieldValue('type') == 91 && form.getFieldValue('is_click') ==1">
          <a-form-item :label="$t('admin.column.add.jumpTo.label')" :colon="false">
            <a-select 
              allowClear 
              v-decorator="['is_jump', { rules: [{ required: true, message: $t('admin.column.add.jumpTo.required') }] }]" 
              :placeholder="$t('admin.column.add.jumpTo.placeholder')">
              <a-select-option value="1">{{ $t('admin.column.add.jumpTo.schoolResource') }}</a-select-option>
              <a-select-option value="2">{{ $t('admin.column.add.jumpTo.localResource') }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.column.add.submit') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import cookie from 'js-cookie'

import {
  columnSave,
  columnDetail,
  columnType
} from '@/api/admin'
import md5 from 'md5'

export default {
  data() {
    return {
      typeList: [],
      stateList: [
        {
          id: 1,
          name: this.$t('status.default.open')
        },
        {
          id: 2,
          name: this.$t('status.default.close')
        }
      ],
      id: undefined,
      addonAfter: '.' + location.hostname,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'columnList'
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: this.id,
            username: values.username + this.shortName,
            password: values.password ? md5(values.password) : undefined
          })
          delete data.repassword
          console.log('Received values of form: ', data)
          columnSave(data).then(res => {
            if (res.code == 200) {
              const tip = this.id ? this.$t('admin.column.add.success.edit') : this.$t('admin.column.add.success.create')
              this.$message.success(tip)
              if (cookie.getJSON('user_infor').id == this.id) {
                const user = Object.assign(cookie.getJSON('user_infor'), {
                  name: values.name,
                  username: values.username
                })
                cookie.set('user_infor', user)
              }
              this.$router.push({
                name: 'columnList'
              })
            }
          })
        }
      })
    },
    getColumnDetail() {
      columnDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          let isJump = res.data.isJump.toString()
          let isClick = res.data.isClick.toString()
          this.form.setFieldsValue({
            title: res.data.title,
            status: res.data.status,
            type: res.data.type,
            is_click:isClick=='0'?undefined:isClick,
          })
          setTimeout(() => {
            this.form.setFieldsValue({
              is_jump:isJump=='0'?undefined:isJump,
            })
          }, 20)

          this.$nextTick(() => {
            if (res.data.type == 5) {
              this.form.setFieldsValue({
                link: res.data.link
              })
            }
            if (res.data.type == 90) {
              this.form.setFieldsValue({
                customDomainPrefix: res.data.customDomainPrefix
              })
            }
          })
        }
      })
    },
    async getTypeList() {
      const res = await columnType()
      if (res.code == 200) {
        this.typeList = res.data.list
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.form.setFieldsValue({
      is_click: '1',
    })
    if (this.id) {
      this.getColumnDetail()
    }
    this.getTypeList()
  }
}
</script>

<style lang="less" scoped>
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
.back{
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #D6D6D6;
  img{
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form{
  .title{
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #EDEDED;
    &::before{
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6B738C;
    }
  }
  .list_wrap{
    display: flex;
    justify-content: space-between;
    flex-wrap:wrap;
  }
  .list{
    width: 50%;
    .ant-form-item-label label{
      color: #000000;
    }
    .ant-form-item{
      width: 100%;
      padding-left: 45px;
      &:first-child{
        padding-left: 0;
        padding-right: 45px;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix{
      position: absolute;
      img{
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div{
      position: relative;
      .ant-calendar-picker-input{
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #D8DCE0;
      }

    }
    .ant-input,
    .ant-select{
      border-radius: 4px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select{
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
    .ant-input-wrapper.ant-input-group{
      .ant-input{
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon{
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5E7A92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button{
    width: 100%;
    // padding-left: 500px;
    text-align: center;
    margin-top: 50px;
  }
}
</style>
